<template>
    <div id="Footer" @click.self="closeDropdown">
        <div class="translate" @click="toggleDropdown">
            <div class="icon">
                <TranslateEarth />
            </div>
            <div class="label">
                {{ selectedLanguage.name }}
            </div>
            <div class="btn">
                <DownBtnIcon />
            </div>
        </div>

        <ul v-if="dropdownOpen" class="dropdown">
            <li v-for="(lang, index) in languages"
                :key="index"
                @click="selectLanguage(lang)"
                :class="{ 'selected': lang.code === selectedLanguageCode }">
                {{ lang.name }}
            </li>
        </ul>

        <div :class="['back-btn', { hidden: !showBackBtn }]" @click="handleBackClick">
            <span class="label">{{ $t("backLabel") }}</span>
            <BackBtn class="icon" />
        </div>
        <div class="next-btn"
             @click="handleNextClick"
             v-if="showNextButton"
             :class="{'disabled': isNextButtonDisabled}">
            <NextBtnGray class="icon" v-if="isNextButtonDisabled" />
            <NextBtnColourful class="icon" v-else />
            <span :class="['label', { 'gray-label': isNextButtonDisabled }]">{{ $t("continueLabel") }}</span>
        </div>
        <div class="btn-done" @click="handleCompleteClick" v-if="showCompleteButton">
            <NextBtnWhite class="icon" />
            <span class="label">{{ $t("completeSetupLabel") }}</span>
        </div>
    </div>
</template>

<script>
import BackBtn from "../icon/BackBtn.vue";
import NextBtnColourful from "../icon/NextBtnColourful.vue";
import NextBtnGray from "../icon/NextBtnGray.vue";
import NextBtnWhite from "../icon/NextBtnWhite.vue";
import DownBtnIcon from "../icon/DownBtnIcon.vue";
import TranslateEarth from "../icon/TranslateEarth.vue";
import { loadFromLocalStorage, saveToLocalStorage, clearLocalStorage } from "../../utils/formStore";

export default {
    name: "FooterItem",
    components: {
        BackBtn,
        NextBtnColourful,
        NextBtnGray,
        NextBtnWhite,
        DownBtnIcon,
        TranslateEarth,
    },
    data() {
        return {
            selectedLanguage: { name: "Türkçe", code: "tr" },
            selectedLanguageCode: "tr",
            dropdownOpen: false,
            languages: [
                { name: "Türkçe", code: "tr" },
                { name: "English", code: "en" },
                { name: "Русский", code: "ru" },
                { name: "Deutsch", code: "de" },
                { name: "Français", code: "fr" },
                { name: "Español", code: "es" },
                { name: "عربي", code: "ar" },
                { name: "Italiano", code: "it" },
            ],
            showBackBtn: false,
            nextBtnColor: "#333",
            backClicked: false,
            userCompleted: false
        };
    },
    props: {
        currentPage: {
            type: String,
            required: true
        },
        isNextButtonDisabled: {
            type: Boolean,
            default: false
        },
        siteId: {
            type: String,
            required: true
        },
    },
    computed: {
        showCompleteButton() {
            return this.currentPage === 'pageFive' && !this.backClicked;
        },
        showNextButton() {
            return !this.showCompleteButton;
        },
        siteName() {
            const urlParams = new URLSearchParams(window.location.search);
            return urlParams.get("sitename") || "code1.local.supsis.live";
        },
    },
    methods: {
        toggleDropdown() {
            this.dropdownOpen = !this.dropdownOpen;
        },
        selectLanguage(lang) {
            this.selectedLanguage = lang;
            this.selectedLanguageCode = lang.code;
            this.dropdownOpen = false;
            this.changeLanguage(lang.code);
        },
        changeLanguage(code) {
            this.$i18n.locale = code;
        },
        handleNextClick() {
            if (!this.isNextButtonDisabled) {
                this.showBackBtn = true;
                this.nextBtnColor = "#5a2ee8";
                this.backClicked = false;
                this.$emit('next-page');
            }
        },
        handleBackClick() {
            this.backClicked = true;
            this.$emit('previous-page');
        },
        closeDropdown() {
            this.dropdownOpen = false;
        },
        handleClickOutside(event) {
            if (!this.$el.contains(event.target)) {
                this.closeDropdown();
            }
        },
        handleCompleteClick() {
            const elapsed = this.$parent.elapsedSeconds;
            const remaining = Math.max(45 - elapsed, 0);

            if (remaining > 0) {
                this.$parent.showSetupCompletion = true;

                setTimeout(() => {
                    this.sendDataToAPI().then((passwordlessLink) => {
                        clearLocalStorage();
                        window.location.href = passwordlessLink;
                    });
                }, remaining * 1000);

            } else {
                this.sendDataToAPI().then((passwordlessLink) => {
                    clearLocalStorage();
                    window.location.href = passwordlessLink;
                });
            }
        },
        sendDataToAPI() {
            return new Promise((resolve) => {
                const formData = loadFromLocalStorage();
                const dataToSend = { ...formData };
                delete dataToSend.completedPages;

                // bu kısım master apisi ile değiştirilecek
                // beta api
                // fetch("https://beta-api.supsis.live/api/sites/save-lobby-data", {
                // master api
                fetch("https://api.supsis.live/api/sites/save-lobby-data", {
                // local api
                // fetch('https://tablet-api-local.supsis.live/api/sites/save-lobby-data', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'site-id': this.siteId
                    },
                    body: JSON.stringify({
                        siteId: this.siteId,
                        lobbyData: dataToSend
                    })
                })
                    .then(response => {
                        if (!response.ok) throw new Error('Network error');
                        console.log('API Response:', response);
                        return response.json();
                    })
                    .then(data => {
                        console.log('API Success:', data);
                        resolve(data.passwordlessLink);
                    })
                    .catch(error => {
                        console.error('API Error:', error);
                        resolve(false);
                    });
            });
        },
        redirectToGoogle() {
            // Implement the logic to redirect to Google
        },
        showSetupCompletion() {
            // Implement the logic to show setup completion
        },
        redirectToSupsisPanel() {
            // Implement the logic to redirect to Supsis Panel
        }
    },
    mounted() {
        document.addEventListener("click", this.handleClickOutside);
    },
    beforeDestroy() {
        document.removeEventListener("click", this.handleClickOutside);
    },
    watch: {
        formData: {
            handler(newVal) {
                saveToLocalStorage(newVal);
            },
            deep: true
        }
    }
};
</script>

<style lang="scss">
#Footer {
    background-color: #fff;
    display: flex;
    padding: 10px;
    gap: 10px;
    justify-content: center;
    position: relative;

    .next-btn {
        border: 1px solid #DFDFDF;
        height: 40px;
        width: 50%;
        display: flex;
        align-items: center;
        font-size: 16px;
        cursor: pointer;
        border-top-left-radius: 30px;
        border-bottom-left-radius: 30px;

        .icon {
            margin: 0 8px;
            font-weight: bold;
            padding-left: 20px;
        }

        .label {
            font-weight: bold;
            padding-left: 20px;

        }

        .gray-label {
            color: #ABA6C8;
        }
    }

    .btn-done {
        border: 1px solid #5625CC;
        background: #5625CC;
        height: 40px;
        width: 50%;
        display: flex;
        align-items: center;
        font-size: 16px;
        cursor: pointer;
        border-top-left-radius: 30px;
        border-bottom-left-radius: 30px;

        .icon {
            margin: 0 8px;
            font-weight: bold;
        }

        .label {
            color: white;
            font-weight: bold;
        }
    }

    .back-btn {
        border: 1px solid #DFDFDF;
        height: 40px;
        justify-content: flex-end;
        width: 50%;
        display: flex;
        align-items: center;
        font-size: 16px;
        cursor: pointer;
        border-top-right-radius: 30px;
        border-bottom-right-radius: 30px;

        .icon {
            margin: 0 8px;
            font-weight: bold;
            padding-right: 15px;
        }

        .label {
            font-weight: bold;
            padding-right: 15px;

        }
    }

    .back-btn.hidden {
        visibility: hidden;
    }

    .translate {
        position: absolute;
        right: 0;
        bottom: 70px;
        display: flex;
        align-items: stretch;
        gap: 10px;
        cursor: pointer;
        padding: 10px 20px;
        z-index: 10;

        .icon,
        .label,
        .btn {
            font-size: 16px;
            font-weight: bold;
        }

        @media screen and (max-width: 768px) {
            .label,
            .btn {
                display: none;
            }
        }
    }

    .dropdown {
        position: absolute;
        bottom: 100%;
        right: 0;
        background: white;
        border: 1px solid #ccc;
        border-radius: 5px;
        list-style: none;
        padding: 0;
        margin-bottom: 10px;
        width: 150px;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        z-index: 20;
    }

    .dropdown li {
        padding: 10px;
        cursor: pointer;
        font-size: 16px;
    }

    .dropdown li:hover {
        background: #f0f0f0;
    }

    .dropdown li.selected {
        font-weight: bold;
        background-color: #f0f0f0;
    }
}
</style>